/* La Case 24 — comportements des sections lc24-* (sans dépendance). Idempotent : sûr à relancer dans l'éditeur de thème. */
(function () {
  'use strict';

  function jours() {
    var n = new Date(), t = new Date(n.getFullYear(), 11, 1);
    if (n > t) t = new Date(n.getFullYear() + 1, 11, 1);
    return Math.round((t - new Date(n.getFullYear(), n.getMonth(), n.getDate())) / 864e5);
  }

  function hautDeGroupe() {
    // l'en-tête colle en haut, le bandeau d'annonce défile avec la page
    var g = document.getElementById('header-group'), bar = document.querySelector('.lc-bar'), st = document.querySelector('.lc-top .lc-stripe');
    if (!g || !bar) return;
    var h = bar.offsetHeight + (st ? st.offsetHeight : 0);
    g.style.setProperty('--lc-top', '-' + h + 'px');
  }

  function livraison(root) {
    var d1 = root.querySelectorAll('[data-lc-d1]'), d2 = root.querySelectorAll('[data-lc-d2]');
    if (!d1.length) return;
    function plus(j) {
      var x = new Date();
      while (j > 0) { x.setDate(x.getDate() + 1); if (x.getDay() !== 0) j--; }
      return x.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
    }
    d1.forEach(function (e) { e.textContent = plus(3); });
    d2.forEach(function (e) { e.textContent = plus(5); });
  }

  function lie(el, cle) {
    if (el.dataset['lc' + cle]) return false;
    el.dataset['lc' + cle] = '1';
    return true;
  }

  // vidéos TikTok : au toucher, la vidéo s'ouvre EN GRAND par-dessus la page et se lance AVEC LE SON
  // (lecteur officiel « player/v1 » de TikTok : lecture auto, puis « unMute » + « play » dès qu'il est prêt).
  var TT = 'https://www.tiktok.com';
  var TT_PARAMS = 'autoplay=1&controls=1&progress_bar=1&play_button=1&volume_control=1&fullscreen_button=1&timestamp=0&loop=0&music_info=0&description=0&rel=0&native_context_menu=0&closed_caption=0';
  var vbox = null, vcadre = null, vsource = null;

  function envoieVideo(type) {
    var f = vcadre && vcadre.querySelector('iframe');
    if (f && f.contentWindow) f.contentWindow.postMessage({ type: type, value: null, 'x-tiktok-player': true }, TT);
  }

  function fermeVideo() {
    if (!vbox || vbox.hidden) return;
    vcadre.innerHTML = '';
    vbox.hidden = true;
    document.documentElement.classList.remove('lc-fige');
    if (vsource) vsource.focus();
  }

  function lecteurVideo() {
    if (vbox) return;
    vbox = document.createElement('div');
    vbox.className = 'lc24 lc-vbox';
    vbox.hidden = true;
    vbox.setAttribute('role', 'dialog');
    vbox.setAttribute('aria-modal', 'true');
    vbox.setAttribute('aria-label', 'Vidéo');
    vbox.innerHTML = '<div class="lc-vbox-in"></div><button type="button" class="lc-vbox-x" aria-label="Fermer la vidéo">✕</button>';
    document.body.appendChild(vbox);
    vcadre = vbox.querySelector('.lc-vbox-in');
    vbox.querySelector('.lc-vbox-x').addEventListener('click', fermeVideo);
    vbox.addEventListener('click', function (e) { if (e.target === vbox) fermeVideo(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') fermeVideo(); });
    window.addEventListener('message', function (e) {
      if (vbox.hidden || e.origin !== TT) return;
      var d = e.data;
      if (typeof d === 'string') { try { d = JSON.parse(d); } catch (_) { return; } }
      if (d && d['x-tiktok-player'] && d.type === 'onPlayerReady') { envoieVideo('unMute'); envoieVideo('play'); }
    });
  }

  function ouvreVideo(b) {
    var mp4 = b.dataset.mp4, id = (b.dataset.id || '').replace(/\D/g, '');
    if (!mp4 && !id) return;
    lecteurVideo();
    vsource = b;
    vcadre.innerHTML = '';
    if (mp4) {
      // fichier de la boutique : lecture immédiate AVEC LE SON (le toucher du client l'autorise), sans TikTok autour
      var v = document.createElement('video');
      v.src = mp4;
      v.controls = true;
      v.preload = 'auto';
      v.setAttribute('playsinline', '');
      v.playsInline = true;
      if (b.dataset.affiche) v.poster = b.dataset.affiche;
      vcadre.appendChild(v);
      v.muted = false;
      var p = v.play();
      if (p && p.catch) p.catch(function () { v.muted = true; v.play(); });
    } else {
      var f = document.createElement('iframe');
      f.src = TT + '/player/v1/' + id + '?' + TT_PARAMS;
      f.allow = 'autoplay; fullscreen; encrypted-media; picture-in-picture';
      f.allowFullscreen = true;
      f.title = b.getAttribute('aria-label') || 'Vidéo TikTok';
      vcadre.appendChild(f);
    }
    vbox.hidden = false;
    document.documentElement.classList.add('lc-fige');
    vbox.querySelector('.lc-vbox-x').focus();
  }

  function init(root) {
    root = root || document;
    var j = jours();
    root.querySelectorAll('.lc-jj').forEach(function (e) { e.textContent = 'J-' + j; });
    root.querySelectorAll('.lc-jj3').forEach(function (e) { e.textContent = j + (j > 1 ? ' jours' : ' jour'); });
    hautDeGroupe();
    livraison(root);

    // flèches des carrousels (ordinateur)
    root.querySelectorAll('.lc-arrows').forEach(function (a) {
      if (!lie(a, 'Ar')) return;
      var rail = a.closest('.lc-wrap').querySelector('.lc-rail'), b = a.querySelectorAll('button');
      if (!rail || b.length < 2) return;
      b[0].addEventListener('click', function () { rail.scrollBy({ left: -rail.clientWidth * 0.8, behavior: 'smooth' }); });
      b[1].addEventListener('click', function () { rail.scrollBy({ left: rail.clientWidth * 0.8, behavior: 'smooth' }); });
    });

    // galerie de la fiche : compteur, points, vignettes
    root.querySelectorAll('[data-lc-galt]').forEach(function (g) {
      if (!lie(g, 'Ga')) return;
      var gal = g.closest('.lc-gal'), dots = gal.querySelectorAll('[data-lc-dots] i'), n = gal.querySelector('[data-lc-galn]');
      g.addEventListener('scroll', function () {
        var i = Math.round(g.scrollLeft / g.clientWidth);
        dots.forEach(function (x, k) { x.classList.toggle('lc-on', k === i); });
        if (n) n.textContent = (i + 1) + ' / ' + dots.length;
      }, { passive: true });
      gal.querySelectorAll('.lc-thumbs img').forEach(function (im, k) {
        im.addEventListener('click', function () { g.scrollTo({ left: k * g.clientWidth, behavior: 'smooth' }); });
      });
    });

    // les 24 cases
    root.querySelectorAll('.lc-cases').forEach(function (bloc) {
      if (!lie(bloc, 'Cs')) return;
      var cs = [].slice.call(bloc.querySelectorAll('button.lc-cs'));
      cs.forEach(function (b) {
        b.addEventListener('click', function () { b.setAttribute('aria-expanded', b.getAttribute('aria-expanded') === 'true' ? 'false' : 'true'); });
      });
      var o = bloc.querySelector('[data-lc-ouvrir]'), f = bloc.querySelector('[data-lc-fermer-tout]');
      if (o) o.addEventListener('click', function () { cs.forEach(function (b, k) { setTimeout(function () { b.setAttribute('aria-expanded', 'true'); }, k * 45); }); });
      if (f) f.addEventListener('click', function () { cs.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); }); });
    });

    // panier : le bouton « Mettre à jour » ne sert qu'aux navigateurs sans JS
    root.querySelectorAll('form.lc-pan .lc-maj').forEach(function (b) { b.hidden = true; });

    // quantité
    root.querySelectorAll('.lc-qty').forEach(function (q) {
      if (!lie(q, 'Qt')) return;
      var inp = q.querySelector('input'), m = q.querySelector('[data-lc-moins]'), p = q.querySelector('[data-lc-plus]');
      // dans le panier, le formulaire part tout seul après le clic (et sans JS, le bouton « Mettre à jour » est là)
      var pan = q.closest('form.lc-pan'), minuteur = null;
      function change(v) {
        inp.value = v;
        if (!pan) return;
        clearTimeout(minuteur);
        minuteur = setTimeout(function () { pan.submit(); }, 450);
      }
      m.addEventListener('click', function () { change(Math.max(pan ? 0 : 1, (+inp.value || 1) - 1)); });
      p.addEventListener('click', function () { change(Math.min(9, (+inp.value || 1) + 1)); });
    });

    // barre d'achat collante : visible quand le bouton principal est passé au-dessus de l'écran
    root.querySelectorAll('[data-lc-sticky]').forEach(function (st) {
      if (!lie(st, 'St')) return;
      var row = document.querySelector('[data-lc-atcrow]');
      if (!row || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (e) {
        st.classList.toggle('lc-on', !e[0].isIntersecting && e[0].boundingClientRect.top < 0);
      }).observe(row);
    });

    // vidéos TikTok : chargées seulement au toucher, ouvertes en grand avec le son
    root.querySelectorAll('button.lc-vd.lc-vrai').forEach(function (b) {
      if (!lie(b, 'Vd')) return;
      b.addEventListener('click', function () { ouvreVideo(b); });
    });

    // filtres de collection : un panneau ouvert à la fois, dans la page
    var bs = [].slice.call(root.querySelectorAll('[data-lc-f]'));
    bs.forEach(function (b) {
      if (!lie(b, 'Fi')) return;
      b.addEventListener('click', function () {
        var ouvert = b.getAttribute('aria-expanded') === 'true';
        bs.forEach(function (x) {
          x.setAttribute('aria-expanded', 'false');
          var p = document.getElementById('lc-' + x.dataset.lcF); if (p) p.classList.remove('lc-on');
        });
        if (!ouvert) {
          b.setAttribute('aria-expanded', 'true');
          var p = document.getElementById('lc-' + b.dataset.lcF); if (p) p.classList.add('lc-on');
        }
      });
    });

    // tri
    root.querySelectorAll('[data-lc-tri]').forEach(function (s) {
      if (!lie(s, 'Tr')) return;
      s.addEventListener('change', function () {
        var u = new URL(window.location.href);
        u.searchParams.set('sort_by', s.value);
        u.searchParams.delete('page');
        window.location.href = u.toString();
      });
    });

    // pied de page : colonnes ouvertes sur ordinateur
    if (window.matchMedia('(min-width:1000px)').matches) {
      root.querySelectorAll('.lc-fcol').forEach(function (x) { x.open = true; });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.addEventListener('resize', hautDeGroupe);
})();
